/* rr-product (FIX-H, 28 Sep 2026): behaviour for sections/rr-product.liquid. Vanilla JS, delegated at document level.
Add to cart = the same hand-off as rr-deluxe.js: POST /cart/add.js, then theme.addToCartOk(item) (theme drawer opens);
fallback without theme.js: fetch + /cart. Without JS the form posts to /cart/add normally. */
(function () {
"use strict";
var R = ".rp-pdp";
function q(r, s) { return r.querySelector(s); }
function qa(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
function up(el, s) { return el && el.closest ? el.closest(s) : null; }
function txt(el, t) { if (el) el.textContent = t; }
function show(el, on) { if (el) { if (on) el.removeAttribute("hidden"); else el.setAttribute("hidden", ""); } }
function gIdx(tr) { return Math.round(tr.scrollLeft / (tr.clientWidth || 1)); }
function gGo(g, i) {
var tr = q(g, ".rp-gallery__track"); if (!tr) return;
i = Math.max(0, Math.min(tr.children.length - 1, i));
tr.scrollTo({ left: i * tr.clientWidth, behavior: "smooth" });
}
function gSync(g) {
var tr = q(g, ".rp-gallery__track"); if (!tr) return;
var i = gIdx(tr), n = tr.children.length;
qa(g, "[data-rp-goto]").forEach(function (b) { b.setAttribute("aria-current", String(+b.getAttribute("data-rp-goto") === i)); });
var p = q(g, ".rp-gallery__arrow--prev"), x = q(g, ".rp-gallery__arrow--next");
if (p) p.disabled = i <= 0;
if (x) x.disabled = i >= n - 1;
}
function gInit(g) {
var tr = q(g, ".rp-gallery__track"); if (!tr || g.__rp) return; g.__rp = 1;
var raf = 0;
tr.addEventListener("scroll", function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; gSync(g); }); }, { passive: true });
tr.addEventListener("keydown", function (e) {
if (e.key === "ArrowRight" || e.key === "ArrowLeft") { e.preventDefault(); gGo(g, gIdx(tr) + (e.key === "ArrowRight" ? 1 : -1)); }
});
gSync(g);
}
function gToMedia(root, mid) {
if (!mid) return;
var slides = qa(root, ".rp-gallery__slide");
for (var i = 0; i < slides.length; i++) if (slides[i].getAttribute("data-rp-media") === String(mid)) { gGo(q(root, ".rp-gallery"), i); return; }
}
function setPrice(root, p, w, s) {
txt(q(root, "[data-rp-now]"), p);
txt(q(root, "[data-rp-was-amt]"), w);
txt(q(root, "[data-rp-save]"), s);
show(q(root, "[data-rp-was]"), !!w);
show(q(root, "[data-rp-save]"), !!s);
txt(q(root, "[data-rp-sticky-now]"), p);
}
function setAtc(root, ok) {
var b = q(root, "[data-rp-atc]"); if (!b) return;
b.disabled = !ok;
txt(q(b, ".rp-atc-label"), ok ? b.getAttribute("data-rp-label") : "Sold out");
}
function vInit(root) {
var data = q(root, "[data-rp-variants]"), opts = q(root, "[data-rp-opts]");
if (!data || !opts || root.__rpv) return; root.__rpv = 1;
try { root.__v = JSON.parse(data.textContent); } catch (e) { return; }
show(opts, true);
show(q(root, "[data-rp-select]"), false);
vSync(root, false);
}
function vSync(root, moveImg) {
var vs = root.__v; if (!vs) return;
var chosen = qa(root, "[data-rp-opts] fieldset").map(function (f) { var c = q(f, "input:checked"); return c ? c.value : null; });
var v = null;
vs.forEach(function (x) { if (!v && x.o.every(function (o, i) { return o === chosen[i]; })) v = x; });
qa(root, "[data-rp-opt-sel]").forEach(function (el) { var c = chosen[+el.getAttribute("data-rp-opt-sel")]; txt(el, String(c || "").split(": ").pop()); });
qa(root, "input[data-rp-opt]").forEach(function (inp) {
var oi = +inp.getAttribute("data-rp-opt");
var ok = vs.some(function (x) { return x.a && x.o[oi] === inp.value && x.o.every(function (o, i) { return i === oi || o === chosen[i]; }); });
inp.parentNode.classList.toggle("is-na", !ok);
});
var sel = q(root, "select[name=id]");
if (!v) { setAtc(root, false); return; }
if (sel && sel.value !== String(v.id)) { sel.value = String(v.id); sel.dispatchEvent(new Event("change", { bubbles: true })); }
setPrice(root, v.p, v.w, v.s);
setAtc(root, v.a);
if (moveImg) gToMedia(root, v.m);
try {
var u = new URL(window.location.href); u.searchParams.set("variant", v.id);
window.history.replaceState(window.history.state, "", u.toString());
} catch (e) {}
}
function tInit(root) {
var ins = qa(root, ".rp-tier__input"); if (!ins.length || root.__rpt) return; root.__rpt = 1;
var f = ins[0].form, hid = document.createElement("input");
hid.type = "hidden"; hid.name = "id"; hid.setAttribute("data-rp-id", "");
f.insertBefore(hid, f.firstChild);
ins.forEach(function (i) { i.name = "rp-tier"; });
var c = q(root, ".rp-tier__input:checked");
if (!c || c.disabled) { c = ins.filter(function (i) { return !i.disabled; })[0]; if (c) c.checked = true; }
tSync(root);
}
function tSync(root) {
var c = q(root, ".rp-tier__input:checked"); if (!c) return;
var hid = q(root, "input[data-rp-id]");
if (hid && hid.value !== c.value) { hid.value = c.value; hid.dispatchEvent(new Event("change", { bubbles: true })); }
setPrice(root, c.getAttribute("data-price"), c.getAttribute("data-was"), c.getAttribute("data-save"));
setAtc(root, true);
var box = q(root, "[data-rp-box]"), items = (c.getAttribute("data-box") || "").split("|").filter(Boolean);
if (box && items.length) {
box.textContent = "";
items.forEach(function (t) { var li = document.createElement("li"); li.textContent = t.trim(); box.appendChild(li); });
}
var img = q(root, ".rp-gallery__slide img"); if (!img) return;
if (!img.hasAttribute("data-o-src")) {
img.setAttribute("data-o-src", img.getAttribute("src") || ""); img.setAttribute("data-o-set", img.getAttribute("srcset") || ""); img.setAttribute("data-o-alt", img.alt);
}
var own = c.getAttribute("data-rp-tier") === (root.getAttribute("data-rp-handle") || ""), src = c.getAttribute("data-img");
if (own || !src) { img.setAttribute("srcset", img.getAttribute("data-o-set")); img.src = img.getAttribute("data-o-src"); img.alt = img.getAttribute("data-o-alt"); }
else { img.setAttribute("srcset", c.getAttribute("data-srcset") || ""); img.src = src; img.alt = c.getAttribute("data-alt") || img.alt; }
}
function sInit(root) {
var bar = q(root, "[data-rp-sticky]"), atc = q(root, "[data-rp-atc]");
if (!bar || !atc || bar.__rp) return; bar.__rp = 1;
var raf = 0, st = null;
function chk() {
raf = 0;
var on = atc.getBoundingClientRect().bottom < 0;
if (on === st) return; st = on;
bar.classList.toggle("is-on", on);
if (on) bar.removeAttribute("inert"); else bar.setAttribute("inert", "");
}
window.addEventListener("scroll", function () { if (!raf) raf = requestAnimationFrame(chk); }, { passive: true });
chk();
}
function submit(form, e) {
e.preventDefault();
var btn = q(form, "[type=submit]"); if (!btn || btn.disabled) return;
var lab = q(btn, ".rp-atc-label"), err = q(form, ".rp-form__error"), idle = lab ? lab.textContent : "";
btn.disabled = true; txt(lab, btn.getAttribute("data-rp-busy") || "Adding…"); show(err, false);
function done() { btn.disabled = false; txt(lab, idle); }
function fail(m) { done(); if (err) { err.textContent = m || "Sorry, something went wrong. Please try again."; show(err, true); } }
var $ = window.jQuery;
if ($ && window.theme && typeof window.theme.addToCartOk === "function") {
$.ajax({ type: "POST", url: "/cart/add.js", dataType: "json", data: $(form).serialize() })
.done(function (item) { done(); try { window.theme.addToCartOk(item); } catch (x) { window.location.href = "/cart"; } })
.fail(function (x) { var d = x && x.responseJSON; fail(d && (d.description || d.message)); });
return;
}
fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) })
.then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
.then(function (r) { if (r.ok) window.location.href = "/cart"; else fail(r.j && (r.j.description || r.j.message)); })
.catch(function () { fail(); });
}
function okLoad() {
var host = document.querySelector(R + " [data-rp-okendo]");
if (!host || window.__rpOke) return; window.__rpOke = 1;
var s = document.createElement("script"); s.src = host.getAttribute("data-rp-okendo"); s.defer = true; document.head.appendChild(s);
}
function okInit() {
var host = document.querySelector(R + " [data-rp-okendo]");
if (!host || window.__rpOke) return;
if (!("IntersectionObserver" in window)) { okLoad(); return; }
var io = new IntersectionObserver(function (en) { if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); okLoad(); } }, { rootMargin: "1200px 0px" });
io.observe(host);
}

document.addEventListener("click", function (e) {
var t = e.target, root = up(t, R), b; if (!root) return;
if (up(t, ".rp-rating")) okLoad();
if ((b = up(t, ".rp-acc__btn"))) {
var p = document.getElementById(b.getAttribute("aria-controls")), open = b.getAttribute("aria-expanded") === "true";
b.setAttribute("aria-expanded", String(!open)); show(p, !open); return;
}
if ((b = up(t, "[data-rp-qty]"))) {
var inp = q(root, ".rp-qty__in");
inp.value = Math.max(1, Math.min(20, (parseInt(inp.value, 10) || 1) + +b.getAttribute("data-rp-qty"))); return;
}
if ((b = up(t, "[data-rp-sticky-atc]"))) {
var f = document.getElementById(b.getAttribute("aria-controls"));
if (f) { if (f.requestSubmit) f.requestSubmit(); else q(f, "[type=submit]").click(); } return;
}
if ((b = up(t, "[data-rp-goto]"))) { gGo(up(b, ".rp-gallery"), +b.getAttribute("data-rp-goto")); return; }
if ((b = up(t, ".rp-gallery__arrow"))) {
var g = up(b, ".rp-gallery"); gGo(g, gIdx(q(g, ".rp-gallery__track")) + (b.classList.contains("rp-gallery__arrow--prev") ? -1 : 1));
}
});
document.addEventListener("change", function (e) {
var root = up(e.target, R); if (!root) return;
if (e.target.matches(".rp-tier__input")) {
var tu = e.target.getAttribute("data-url");
if (tu && e.target.getAttribute("data-rp-tier") !== root.getAttribute("data-rp-handle")) { window.location.assign(tu + window.location.search); return; }
tSync(root); gGo(q(root, ".rp-gallery"), 0);
}
else if (e.target.matches("input[data-rp-opt]")) vSync(root, true);
});
window.addEventListener("pageshow", function () {
qa(document, R).forEach(function (root) {
var own = q(root, '.rp-tier__input[data-rp-tier="' + (root.getAttribute("data-rp-handle") || "") + '"]');
if (own && !own.checked) { own.checked = true; tSync(root); }
});
});
document.addEventListener("submit", function (e) {
var f = up(e.target, R + " form[data-rp-form]"); if (f) submit(f, e);
}, true);

function init() {
qa(document, R).forEach(function (root) {
qa(root, "[data-rp-qty]").forEach(function (b) { show(b, true); });
qa(root, ".rp-gallery").forEach(gInit);
vInit(root); tInit(root); sInit(root);
});
okInit();
}
if (document.readyState !== "loading") init(); else document.addEventListener("DOMContentLoaded", init);
document.addEventListener("shopify:section:load", init);
})();
